import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { AuthProvider } from './context/AuthContext';
import { ProgressProvider } from './context/ProgressContext';
import { CourseStoreProvider } from './context/CourseStoreContext';
import ScrollToTop from './components/feature/ScrollToTop';


function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <ScrollToTop />
      <AuthProvider>
        <CourseStoreProvider>
          <ProgressProvider>
            <AppRoutes />
          </ProgressProvider>
        </CourseStoreProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
